// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Account } from './account';
import { Admin } from './admin';
import { CreditorClaimType } from './creditor-claim-type';
import { CreditorClass } from './creditor-class';
import { CreditorDividend } from './creditor-dividend';
import { Entry } from './entry';
import { ShareholderClass } from './shareholder-class';
import { ShareholderDividend } from './shareholder-dividend';
import { SubEntry } from './sub-entry';
import { User } from './user';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Dividend extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  dividendId!: number;
  adminId!: number;
  adminTypeId!: number;
  admittedTotal!: number;
  authorisedByUserId?: number;
  bankAccountAccountId?: number;
  batchId?: number;
  centsInDollar!: number;
  createdBy!: string;
  createdDate!: Date;
  creditorClaimTypeId?: number;
  creditorClassId?: number;
  dateDeclared!: Date;
  datePaid?: Date;
  dateToProve?: Date;
  description!: string;
  dividendNo!: number;
  equityAccountAccountId?: number;
  flags?: number;
  inSpecieAccountAccountId?: number;
  isFinal!: boolean;
  isPosted!: boolean;
  relatedEntryEntryId?: number;
  shareholderClassId?: number;
  totalAsCapital?: number;
  totalAsIncome?: number;
  totalInSpecie!: number;
  totalPaid!: number;
  totalUnclaimed!: number;
  trustAccountAccountId?: number;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  admin!: Admin;
  authorisedByUser!: User;
  bankAccountAccount!: Account;
  creditorClaimType!: CreditorClaimType;
  creditorClass!: CreditorClass;
  creditorDividends!: CreditorDividend[];
  equityAccountAccount!: Account;
  inSpecieAccountAccount!: Account;
  relatedEntryEntry!: Entry;
  shareholderClass!: ShareholderClass;
  shareholderDividends!: ShareholderDividend[];
  subEntries!: SubEntry[];
  trustAccountAccount!: Account;
}

